module.exports = __webpack_public_path__ + "img/man.1854319d.svg";